export default "July 2, 2021";